const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

export const logService = {
  /**
   * Fetches paginated and filtered logs from the Django backend matrix
   * @param {Object} params - The query filters
   * @param {number} params.page - Current page number
   * @param {string} [params.search] - Optional recipient or project name string
   * @param {string} [params.status] - Optional status flag (SENT/FAILED)
   * @param {number} [params.limit] - Page size
   * @param {Object} [options]
   * @param {AbortSignal} [options.signal] - Optional AbortController signal
   * @returns {Promise<Object>} Django paginated response object containing count and results
   */
  async getAuditLogs({ page = 1, search = "", status = "", limit = 10 } = {}, options = {}) {
    // 1. Setup clean query variables
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (search.trim()) queryParams.append("search", search.trim());
    if (status) queryParams.append("status", status);

    // BUG FIX: queryParams must actually be attached to the URL, otherwise
    // page/limit/search/status are silently dropped on every request.
    const targetUrl = `${BACKEND_URL}/api/logs/?${queryParams.toString()}`;

    // 2. Execute connection request
    const response = await fetch(targetUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // If your JWT system requires authorization, pull the token from localStorage here:
        // "Authorization": `Bearer ${localStorage.getItem('token')}`
      },
      signal: options.signal,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP Network error: ${response.status}`);
    }

    return response.json();
  },
};